import React, { useState, useEffect, useContext, useMemo } from "react";
import { useParams } from 'react-router-dom';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "../AdminDashboard.css";
import MyContext from "../../../MyContext";
import NoIndex from "../../../components//NoIndex";
import { Form, FormControl, Button } from "react-bootstrap";
import QRCode from "qrcode";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";

function AdminDining({ Admin }) {
    const navigate = useNavigate();
    const { baseUrl } = useContext(MyContext);
    const { config } = useContext(MyContext);
    const [loading, setLoading] = useState(false);
    const [Clients, setClients] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [userID, setuserID] = useState('');
    const [ClientName, setClientName] = useState('')
    const [longitude, setLongitude] = useState(null);
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error('Error getting location:', error);
                }
            );
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    }, []);

    const FetchClientCall = async () => {
        setLoading(true);
        try {

            const UserDetail = {
                // userid: User.pkid,
                userid: Admin.pkid,
                latitude: latitude,
                longitude: longitude,
            };

            const response = await axios.post(
                `${baseUrl}/api/Admin/getAllClientList`,
                UserDetail,
                config
            );
            if (response.data.responseCode === "00") {
                // toast.success(response.data.responseMessage);

                setClients(response.data.response);

                setLoading(false);
            } else {
                toast.error(response.data.responseMessage);
            }
        } catch (error) {
            toast.error("error");
            console.error("Error updating Admin login:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        FetchClientCall();
    }, []);
    function HandleClientChange({ code, name }) {
        setuserID(code);
        setClientName(name)

    }

    const [tables, setTables] = useState([]);
    const [qrCodes, setQrCodes] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showAddTableModal, setShowAddTableModal] = useState(false);
    const [newtableNumber, setNewTableNumber] = useState("");
    const [newTable, setNewTable] = useState({
        status: "",
        order: "",
        paymentStatus: "",
    });


    let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";
    const addNewTable = async () => {
        // const newTableData = {
        //   id: tables.length + 1,
        //   status: newTable.status || "available",
        //   order: newTable.order || null,
        //   paymentStatus: newTable.paymentStatus || null,
        // };
        // setTables([...tables, newTableData]);
        // setShowAddTableModal(false);
        // setNewTable({ status: "", order: "", paymentStatus: "" });
        try {
            const requestBody = {
                userid: userID,
                tableNo: newtableNumber,
            };

            const response = await axios.post(
                `${baseUrl}/api/Order/addRestaurantTable`,
                requestBody,
                config
            );
            if (response.data.responseCode === "00") {
                toast.success(response.data.responseMessage);
                setNewTableNumber("");
                closeAddTableModal();
                fetchTableApi();
            } else {
                // Handle failure case
                toast.error(response.data.responseMessage || "Failed to add table"); // Display the error message
                setNewTableNumber("");
            }
        } catch { }
    };
    const fetchTableApi = async () => {
        try {
            const requestBody = {
                userid: userID,
            };

            const response = await axios.post(
                `${baseUrl}/api/Order/getRestaurantTable`,
                requestBody,
                config
            );
            // Access the response correctly
            if (response.data.responseCode === "00") {
                setTables(response.data.response); // Correctly access the response data
                // toast.success(response.data.responseMessage);
            } else {
                setTables([]);
            }
        } catch (error) {
            console.error("Error fetching tables:", error); // Add error logging
            // toast.error("Failed to fetch tables.");
        }
    };


    useEffect(() => {
        fetchTableApi();
    }, [userID]);

    const generateQRCodeURLOnly = async (
        tableId,
        retaurentName,
        qrUrl,
        whatsappNumber,
        message
    ) => {


        // const message1 = `This is Table No. ${tableId}`;
        const message1 =
            "Hello, I’m seated at Table No. 4 and would like to place my order. Thank you!";
        const phoneNumber = "919266525351";
        const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
            message
        )}`;

        try {
            const qrCodeDataUrl = await QRCode.toDataURL(whatsappLink, {
                errorCorrectionLevel: "H",
                margin: 1,
                scale: 38, // 10cm at 96dpi ≈ 378px. scale determines the image size
            });

            const qrImage = new Image();
            qrImage.src = qrCodeDataUrl;

            return new Promise((resolve) => {
                qrImage.onload = () => {
                    const canvas = document.createElement("canvas");
                    const sizeInPixels = 378; // 10cm = 378px at 96dpi
                    canvas.width = sizeInPixels;
                    canvas.height = sizeInPixels;

                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(qrImage, 0, 0, sizeInPixels, sizeInPixels);

                    const finalQRCode = canvas.toDataURL("image/png", 1.0);
                    resolve(finalQRCode);
                };
            });
        } catch (err) {
            console.error("Failed to generate QR Code", err);
            return null;
        }
    };

    const closeModal = () => setShowModal(false);
    const closeAddTableModal = () => setShowAddTableModal(false);
    // Add this function inside AdminDining
const handleDeleteTable = async (tableNo) => {
  const result = await Swal.fire({
    title: "Confirm Delete",
    html: `
      <div style="text-align:left">
        <div><b>Table No:</b> ${tableNo}</div>
      </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
    reverseButtons: true,
    allowOutsideClick: false,
  });

  if (result.isConfirmed) {
    try {
      const requestBody = {
        userid: userID,
        tableNo: tableNo,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/deleteDiningTable`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage || "Table deleted successfully");
        fetchTableApi(); // refresh list
      } else {
        toast.error(response.data.responseMessage || "Failed to delete table");
      }
    } catch (error) {
      console.error("Error deleting table:", error);
      toast.error("Error deleting table");
    }
  }
};


    return (
        <div className="marginRight">
            <>
                <div className="d-flex justify-content-center text-center">
                    <ToastContainer />
                </div>
                <div>
                    <div
                        className="p-4 bg-white"
                        style={{
                            height: "100vh",
                            fontFamily: "Nunito,sans-serif",
                        }}
                    >
                        <div className="row g-3 px-4 admin-catalogue-wrapper">
                            {/* Left Card */}
                            <div className="col-md-4 admin-popup">
                                <div className="admin-left-card-1 text-white p-4 text-start rounded-2 h-100">
                                    <h5 className="fw-bold mb-2 admin-text-animate">Restaurant Dining</h5>
                                    <hr className="admin-divider" />
                                    <p className="mb-0 small admin-text-animate">
                                        Manage and control your restaurant tables, clients, and dining preferences directly from this panel.
                                    </p>
                                </div>
                            </div>

                            {/* Right Card */}
                            <div className="col-md-8 admin-popup">
                                <div className="admin-right-card-1 p-4 rounded-2 h-100">
                                    <h5 className="admin-restaurant-subtitle mb-3">Select Catalogue</h5>
                                    <select
                                        className="form-select form-select-sm admin-custom-dropdown"
                                        aria-label="Select Client"
                                        onChange={(e) => {
                                            const selectedData = JSON.parse(e.target.value);
                                            HandleClientChange(selectedData);
                                        }}
                                    >
                                        <option value="">Select Client...</option>
                                        {Clients.map((item, index) => (
                                            <option
                                                key={index}
                                                value={JSON.stringify({ code: item.us_code, name: item.us_name })}
                                            >
                                                {item.us_code} : {item.us_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>



                        {userID && <div className="px-4">
                            <hr />
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="text-center mb-4 CreateCampaign">
                                    Dining Order Management {ClientName ? " of " + ClientName : ''}
                                </div>
                                <div className="d-flex justify-content-between align-items-center gap-3">
                                    <div className="d-flex justify-content-center mb-4">
                                        <Button
                                            variant="success"
                                            onClick={() => setShowAddTableModal(true)}
                                        >
                                            Add New Table
                                        </Button>
                                    </div>
                                    <div className="d-flex justify-content-center mb-4">
                                        <Button className="btn btn-success" onClick={() => {
                                            // Navigate to the client's dashboard page with the client ID
                                            navigate(`/admin/orders/Dinning/${userID}/${ClientName}`);
                                        }} >
                                            Download QR Codes
                                        </Button>

                                    </div>
                                </div>
                            </div>
                            <Modal
                                show={showAddTableModal}
                                onHide={closeAddTableModal}
                                centered
                                className="custom-modal"
                            >
                                <Modal.Header closeButton className="modal-header-custom">
                                    <Modal.Title className="modal-title-custom">
                                        Add New Table
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="modal-body-custom">
                                    <Form>
                                        <Form.Group>
                                            <Form.Label className="modal-label">
                                                Enter Table Number :
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter table number"
                                                value={newtableNumber} // Make sure newtableNumber is defined in your state
                                                onChange={(e) => setNewTableNumber(e.target.value)} // Directly set the value
                                                className="form-control-custom"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer className="modal-footer-custom">
                                    <Button
                                        variant="outline-secondary"
                                        onClick={closeAddTableModal}
                                        className="modal-btn"
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onClick={addNewTable}
                                        className="modal-btn-primary"
                                        disabled={!newtableNumber} // Disable button if newtableNumber is empty or undefined
                                    >
                                        Add Table
                                    </Button>
                                </Modal.Footer>
                            </Modal>



                            <div className="row dining-table-row">
                                {tables.map((table) => (
                                   <div className="col-6 col-md-12 dining-table-col" key={table.id}>
  <div
    className={`dining-table-card ${
      table.status !== "Open"
        ? "dining-table-booked"
        : "dining-table-available"
    }`}
  >
    <div className="d-flex justify-content-between align-items-center">
      <h3 className="dining-table-title">Table {table.tableNo}</h3>
      <Button
        variant="danger"
        size="sm"
        onClick={() => handleDeleteTable(table.tableNo)}
      >
        Delete
      </Button>
    </div>
    <p className="dining-table-status">
      Status:{" "}
      <span>
        {table.status !== "Open" ? "Booked" : "Available"}
      </span>
    </p>
  </div>
</div>

                                ))}
                            </div>
                        </div>}


                    </div>
                </div>
            </>
        </div>
    )
}

export default AdminDining